import { render } from "./Page5.vue?vue&type=template&id=ac259c5c&scoped=true"
import script from "./Page5.vue?vue&type=script&lang=js"
export * from "./Page5.vue?vue&type=script&lang=js"

import "./Page5.vue?vue&type=style&index=0&id=ac259c5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac259c5c"]])

export default __exports__